import { Component, HostBinding, viewChild, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Pet } from '@app/models/pet.model';
import { PetType } from '@app/models/petType.model';
import { ContentService } from '@app/services/content.service';
import { PetService } from '@app/services/pet.service';
import { BrnSheet } from '@spartan-ng/brain/sheet';
import { PetInformationComponent } from '../pet-information/pet-information.component';

@Component({
    selector: 'app-add-pet',
    templateUrl: './add-pet.component.html',
    styleUrls: ['./add-pet.component.css'],
    standalone: false,
})
export class AddPetComponent {
    @HostBinding('class') classes = 'add-pet-component-container';
    @ViewChild('petInfo') petInfoComponent: { formGroup: FormGroup } | undefined;
    @ViewChild(PetInformationComponent) petInformationComponent: PetInformationComponent | undefined;
    isValidPetForm = false;
    isSaving = false;
    public readonly sheetRef = viewChild<BrnSheet>('sheet');

    constructor(
        public contentService: ContentService,
        private petService: PetService
    ) {}

    public closeBottomSheet() {
        this.sheetRef()?.close();
    }

    public onReviewDetails() {
        const petInfoComponent = this.petInfoComponent ?? this.petInformationComponent;
        if (!this.isValidPetForm || !petInfoComponent?.formGroup) {
            return;
        }

        this.isSaving = true;
        const formValue = petInfoComponent.formGroup.value;

        const petName = (formValue?.name ?? '').toString().trim();
        if (!petName) {
            this.isSaving = false;
            return;
        }

        const pet: Pet = {
            name: petName,
        };

        if (formValue?.petType) {
            const petType: PetType = {
                id: formValue.petType.id,
                name: formValue.petType.name,
                petBreedList: [],
            };

            if (formValue.petBreed) {
                petType.petBreedList.push({
                    id: formValue.petBreed.id,
                    name: formValue.petBreed.name,
                    typeID: formValue.petBreed.typeID,
                });
                pet.petBreed = formValue.petBreed;
            }
            pet.petType = petType;
        }

        if (formValue?.weight) {
            pet.weight = formValue.weight;
        }
        this.petService.addPet(pet);
        this.closeBottomSheet();
    }
}
